/** Creates a checkbox and checkbox label input to be used with horizontal form fields */
import React from 'react';
import styled from 'styled-components';
import { Checkbox, CHECKBOX_STATUS } from 'ui/checkbox';
import { body2Medium, colors, spacing } from 'ui/theme';
import { TopTooltip } from 'ui/tooltip';
import { FormFieldTooltipContent } from './EditorContentContainer.styled';
import { displayContent } from './content';
import { getIsEditMode } from './utils';
import { useQueryParamContext } from '../context/QueryParamContext';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';
import { MessageMedium } from '../../../constants/messageMediums';
import { useTemplateQueryContext } from '../context/TemplateQueryContext';
import { useSMSLinkShortening } from '../EditSMS/context/SMSLinkShorteningContext';
import { GOOGLE_ANALYTICS_DISPLAY_CONTENT, LINK_PARAMETERS_DISPLAY_CONTENT } from './constants';

export const CheckboxLabel = styled.div`
  ${body2Medium};
  color: ${colors.textSecondary};
  margin-left: ${spacing.half};
  display: inline-block;
  margin-top: -${spacing.eighth};
`;

export const CheckboxWrapper = styled.div`
  display: flex;
`;

export const CheckboxField = ({
  isDisabled = false,
  label,
  status,
  onClick,
}: {
  isDisabled?: boolean;
  label: string | React.ReactNode;
  status: boolean;
  onClick: () => void;
}) => {
  const { view } = useQueryParamContext();
  const { isEditMode } = useEditableFieldsContext();
  const { medium } = useTemplateQueryContext();
  const { isSMSLinkShorteningEnabled } = useSMSLinkShortening();
  const isEditModeVisible = getIsEditMode(view, isEditMode);
  /** Check if SMS link shortening is enabled */
  const isFormFieldDisabled = medium === MessageMedium.SMS ? !isSMSLinkShorteningEnabled : false;
  const enableTooltip =
    (isEditModeVisible &&
      isFormFieldDisabled &&
      !isSMSLinkShorteningEnabled && // Show tooltip in Google Analytics and Link Parameter field only when Shorten and track is disabled.
      label === GOOGLE_ANALYTICS_DISPLAY_CONTENT.checkboxLabel) ||
    label === LINK_PARAMETERS_DISPLAY_CONTENT.checkboxLabel; // To show tooltip when Shorten and Tracks checkbox is not checked.

  return (
    <CheckboxWrapper>
      <TopTooltip
        isEnabled={enableTooltip}
        tooltipContent={
          <FormFieldTooltipContent>
            {displayContent.linksSectionDisabledTooltip}
          </FormFieldTooltipContent>
        }
      >
        <Checkbox
          isDisabled={isDisabled}
          onClick={onClick}
          status={status ? CHECKBOX_STATUS.CHECKED : CHECKBOX_STATUS.UNCHECKED}
        />
      </TopTooltip>
      <CheckboxLabel>{label}</CheckboxLabel>
    </CheckboxWrapper>
  );
};
